import axios from '@/lib/axios'
import { buildAdminRequestConfig, type OrganizationId } from '@/lib/organization-scoping'
import type { QueryFunctionContext } from '@tanstack/react-query'
import type { Role, RoleDetail, RoleIdInput } from './roles.types'

export interface RoleOrganizationScope {
  organizationId: OrganizationId
}

/** Scope for calls that read one role. */
export interface RoleScope extends RoleOrganizationScope {
  roleId?: RoleIdInput
}

/** Query functions read only the key. */
type RoleQueryContext<TKey> = Pick<QueryFunctionContext<[TKey]>, 'queryKey'>

/** `RoleController::index()` reads only the organization, so the role list takes no filters. */
export async function getRoles({
  queryKey: [{ organizationId }],
}: RoleQueryContext<RoleOrganizationScope>) {
  return (await axios.get<Role[]>('/roles', buildAdminRequestConfig({ organizationId }))) || []
}

export async function getRole({
  queryKey: [{ organizationId, roleId }],
}: RoleQueryContext<RoleScope>) {
  return (
    (await axios.get<RoleDetail>(
      `/roles/${roleId}`,
      buildAdminRequestConfig({ organizationId })
    )) || null
  )
}
